import React from "react";
import type { PathArray } from "common/utils/formStructure";
import { Text } from "../../../../../../../Inputs/react-hook-form";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../../form/form";

type HelperTextInputProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

export function HelperTextInput({
  fieldPath,
  isReadOnly,
}: HelperTextInputProps) {
  const { register } = useBuilderFormContext();
  const helperTextPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "helperText",
  );

  return (
    <Text
      label="Helper text"
      disabled={isReadOnly}
      {...register(helperTextPropertyFormPath)}
    />
  );
}
